import React from 'react';
import { Button, ButtonProps } from 'rsuite5';
import { TypeAttributes } from 'rsuite5/esm/@types/common';

const BicesterButton = ({
  appearance = 'primary',
  bgColor = '#455255',
  style,
  ...props
}: {
  bgColor?: string;
} & ButtonProps) => {
  return (
    <Button
      appearance={appearance}
      style={{ ...(appearance === 'primary' && { backgroundColor: bgColor }), ...style }}
      {...props}
    />
  );
};

export default BicesterButton;
